module.exports = __webpack_public_path__ + "static/media/hackingscenarios.cf57d097.png";